import { Component } from '@angular/core';

@Component({
  selector: 'uni-table-details',
  templateUrl: './uni-table-details.component.html',
  styleUrls: ['./uni-table-details.component.scss'],
})
export class UniTableDetailsComponent {}
